'use client';

import { defineMessages, useIntl } from 'react-intl';

export const messages = defineMessages({
  weeeTakeBackMessage: {
    id: 'BusinessTerms.WEEETakeBackAddition',
    defaultMessage: 'Über die gesetzliche Möglichkeit zur Altgeräte-Rücknahme wurde informiert.',
  },
});

/** Hint about the WEEE old-device take-back directive, shown when basket.showWEEETakeBackHint is set. */
export const WeeeTakeBackHint = () => {
  const { formatMessage } = useIntl();
  return (
    <div className="text-size-body-xs mt-0.5">{formatMessage(messages.weeeTakeBackMessage)}</div>
  );
};
